export { SmHotelGalleryTitle } from './HotelGalleryTitle';
export { HotelGalleryTitleEditable } from './HotelGalleryTitle';
export type { ResponseDataProps } from './HotelGalleryTitle.types';
